import { types } from "mobx-state-tree";
import customtypes from "../../utils/mobx-types-helper";

const TableAmountDataModel = types
  .model("TableAmountDataModel", {
    code: customtypes.optional(types.string, ""),
    title: customtypes.optional(types.string, ""),
    amount: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setAmount: (amount: number) => {
      self.amount = amount;
    },
  }));

export type ITableAmountDataModel = typeof TableAmountDataModel.Type;
export default TableAmountDataModel;
